(() => {
  const monthlyPlan = '.select-camping-subscription-monthly-plan'
  const yearlyPlan = '.select-camping-subscription-yearly-plan'

  const init = () => {
    if (location.href.indexOf('customer/mypage/camping_subscription/plan') < 1 ) {
      return
    }

    $('.js-camping_subscription-monthly-price').hide()
    $('.js-camping_subscription-yearly-price').hide()
    $('body')
      .on('click', monthlyPlan, showPrice)
      .on('click', '.camping-subscription-monthly', showPrice)
      .on('click', yearlyPlan, showPrice)
      .on('click', '.camping-subscription-yearly', showPrice)
    showPrice()
  }
  const showPrice = () => {
    if ($('.select-camping-subscription-monthly-plan').is(':checked')) {
      $('.js-camping_subscription-yearly-price').hide()
      $('.js-camping_subscription-monthly-price').show()
    }
    else if ($('.select-camping-subscription-yearly-plan').is(':checked')) {
      $('.js-camping_subscription-monthly-price').hide()
      $('.js-camping_subscription-yearly-price').show()
    }
  }
  $(init);
})();

